import { Box, Heading, Stack, Text, Image, Link as ChakraLink, List } from '@chakra-ui/react';
import { Prose } from '@/components/ui/prose';

const CPSSL = () => {
  const imageSrc = '/cpssl.jpg';

  return (
    <Stack
      w='full'
      minHeight='content-height'
      overflow='auto'
      paddingTop={{ base: '4', md: '10' }}
      paddingBottom={{ base: '6', md: '16' }}
      paddingInline={{ base: 0, md: '8', lg: '12' }}
    >
      <Box>
        <Heading as='h1' size='2xl' mb='6'>
          CPSSL
        </Heading>
        <Box bg='white' p={{ base: 4, md: 6 }} borderRadius='md' borderWidth='1px'>
          <Prose maxWidth='full' size='lg'>
            <Heading as='h3' size='lg'>The Canadian Prairie Soil Spectral Library</Heading>
            <Text>
              The need to sustainably meet the growing food demand under a changing climate will
              require improved soil management. There is also a rapid shift in agriculture towards a
              data-driven approach to enhance decision-making for enhanced productivity,
              sustainability and profitability. The Canadian prairies accounts for more than 80% of
              the arable land in Canada, so effective soil management in this region has national
              implications. However, the lack of critical soil information at precise temporal and
              spatial scales is a major barrier, due in part to cost.
            </Text>
            <Text>
              The application of soil spectroscopy has emerged as a valuable solution. This technology
              enables rapid and comprehensive soil analysis through advanced modeling techniques with
              soil spectral libraries (SSLs). These SSLs combine soil spectra with conventionally
              measured soil information, creating a valuable resource for researchers and
              practitioners. The Canadian Prairie Soil Spectral Library (CPSSL) is therefore being
              developed through a collaborative effort with a multidisciplinary team to fill these
              critical gaps in soil information.
            </Text>
            <Text>
              The CPSSL will be the first regional SSL in Canada and tailored to the unique
              characteristics of the Canadian prairies. The main objectives of the CPSSL are:
            </Text>
            <List.Root as='ol'>
              <List.Item>
                acquire and harmonize legacy soil data for research, monitoring and assessment in the
                Canadian prairies
              </List.Item>
              <List.Item>
                establish the CPSSL with soil property data, spectral data, and metadata (e.g.,
                location, spatial coordinates, sampling year and depth, land cover)
              </List.Item>
              <List.Item>
                develop and validate prediction models using machine learning for low-cost and
                efficient assessment of soil properties in the Canadian prairies.
              </List.Item>
            </List.Root>
            <Text>
              The CPSSL employs visible and near-infrared reflectance (Vis-NIR) spectroscopy and
              leverages legacy soil data spanning diverse geographic regions, depths, annual and
              perennial cropping systems, and sampling years. It is being constructed through benchtop
              spectroscopic analysis of air-dried and sieved soils (&lt; 2 mm) within the Vis-NIR
              spectral range (350 – 2500 nm). The library currently contains 8396 soil spectra with
              associated soil property data and metadata. Associated soil data include soil organic
              carbon, total carbon, inorganic carbon, total nitrogen, pH, electrical conductivity,
              sand, silt, clay, and bulk density.
            </Text>
            <Heading as='h3' size='md'>Average reflectance spectra of the various soil types in the Canadian prairies</Heading>
            <Image
              src={imageSrc}
              alt='Average reflectance spectra of soil types in the Canadian prairies'
              maxW='100%'
              height='auto'
            />
            <Text>
              The establishment of the CPSSL signifies a significant step towards addressing the
              scarcity of critical soil information in the Canadian prairies. This initiative promises
              to enhance our understanding of soil resources, foster sustainable soil management
              practices, and contribute to both scientific advancement and societal well-being.
            </Text>
            <Text>
              For more information about the CPSSL, please contact Dr. Mervin St. Luce (
              <ChakraLink href='mailto:mervin.stluce@agr.gc.ca'>mervin.stluce@agr.gc.ca</ChakraLink>
              ).
            </Text>
          </Prose>
        </Box>
      </Box>
    </Stack>
  );
};

export default CPSSL;


